import React from "react";
import RenderIcons from "../../../Assets/css/_icons/partner_icon/RenderIcons";
import { CloseDialogContext } from "../../../components/common/DialogComponent";
import { useTranslation } from "react-i18next";

interface IProps {
    packageLookup?: any;
    idfOfferLookup?: any;
    packageName: string;
    setFocus?: any;
}
const RegistrationPlanInfoDialog = ({ packageLookup, idfOfferLookup, packageName,setFocus }: IProps) => {
    const close: any = React.useContext(CloseDialogContext);
    const serviceList: any = packageLookup && packageLookup["packageServicesList"];
    const packageDetails = packageLookup && packageLookup["packagDetails"][0];
    const serviceDetails = idfOfferLookup && idfOfferLookup["serviceDetails"] ? idfOfferLookup["serviceDetails"] : [];
    const { t: tLang } = useTranslation();
    const closeDialog = () => {
        close("whatsIncluded");
        setFocus();
    };
    let items: any = [];
    if (serviceList) {
        for (let key in serviceList) {
            let productId = packageDetails?.packageServiceslst?.find(
                (it: { serviceName: string }) => it.serviceName.trim().toLowerCase() === key.trim().toLowerCase()
            )?.product;
            // 182 = SVCLVL-TU-AUTH, 191 = SVC-TU-CRD-NOTIFICATION-ONLY, 197 = SVCLVL-TU-CA-AUTH
            // Task 25458: [TU Autoenroll] Hide notification only and transaction authentication from "Whats included in your package" from registration step 1
            if (![182, 191, 197].includes(productId)) {
                let value = serviceList[key];
                items.push({
                    header: <h3 className="inner-title">{key}</h3>,
                    body: value.replace('<ul class="bulleted_list serviceDescription">', '<ul class="list-reset list-condensed">'),
                });
            }
        }
    }

    return (
        <div>
            <div className="dialog-header">
                <div className="dialog-icon">
                    <RenderIcons iconName="question" />
                </div>
                <h1>{tLang("registration.plan.whatsIncludedInPopUp.title", { packageName: packageName })}</h1>
            </div>
            <div tabIndex={0} style={{ maxHeight: "250px" }} className="dialog-body small-dialog-scroll cartHeight" role="document">
                {items &&
                    items.length > 0 &&
                    items.map((item: any, index: number) => {
                        return (
                            <div key={index}>
                                {item.header}
                                <div dangerouslySetInnerHTML={{ __html: item.body }}></div>
                                <div className="margin-vertical-s"></div>
                            </div>
                        );
                    })}

                {serviceDetails &&
                    serviceDetails.length > 0 &&
                    serviceDetails.map((service: any, index: number) => {
                        return (
                            <div key={index}>
                                <h3 className="inner-title">{service["serviceName"] && service["serviceName"]}</h3>
                                <div>
                                    <p>{service["serviceDescription"] && service["serviceDescription"]}</p>
                                </div>
                            </div>
                        );
                    })}
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null" style={{ marginRight: "20px" }}>
                        <button onClick={() => closeDialog()} type="button" className="btn-default btn-primary">
                            <span className="btn-text">{tLang("registration.plan.whatsIncludedInPopUp.closeButtonText")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegistrationPlanInfoDialog;
